import {Component} from '@angular/core';
import {CalendarWeekViewComponent} from 'angular-calendar';

@Component({
  selector: 'ngx-calendar-week-view',
  template: `
    <div class="cal-week-view" role="grid">
      <mwl-calendar-week-view-header
        [days]="days" 
        (dayHeaderClicked)="dayHeaderClicked.emit($event)" 
      >
      </mwl-calendar-week-view-header>
          
      
    </div>
  `,
  styles:[`
  .cal-week-view .cal-day-headers {
    display: flex;
    padding-left: 70px;
    border: 0px solid !important;
  }
  .cal-week-view {
    background-color:transparent !important; 
    border-top: solid 0px #e1e1e1 !important;
  }`]
})
export class CustomWeekView extends CalendarWeekViewComponent {}